import Axios from "API/Axios";
import { AxiosMethodEnum } from "API/Axios";
import { Axios_Route } from "API/AxiosRouts";
import React, { useEffect, useState, FormEvent } from "react";

interface Props {
  Component: any;
}

const ListAgent: React.FC<Props> = ({ Component }) => {
  const [listAgentDataGot, setListAgentDataGot] = useState<boolean>(false);
  const [listAgentData, setListAgentData] = useState<any>();
  const [nameQuery, setNameQuery] = useState<string>("");
  const [mobileQuery, setMobileQuery] = useState<string>("");
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [isSreach, setIsSreach] = useState<boolean>(false);

  useEffect(() => {
    if (isSreach) {
      searchHandler(undefined, pageNumber);
    } else {
      Axios(AxiosMethodEnum.get, Axios_Route.LIST_AGENT, {
        pageNumber: pageNumber,
        pageSize: 20,
      }).then(({ response, success }) => {
        if (success) {
          setListAgentData(response);
          setListAgentDataGot(true);
        }
      });
    }
  }, [pageNumber]);

  const searchHandler = (e?: FormEvent, pageNumber: number = 1) => {
    if (e !== undefined) {
      e.preventDefault();
    }

    const SearchObj = {
      fullName: nameQuery,
      isCount: true,
      mobile: mobileQuery,
      pageNumber: pageNumber,
      pageSize: 20,
    };
    Axios(AxiosMethodEnum.post, Axios_Route.LIST_AGENT_SEARCH, SearchObj).then(
      ({ response, success }) => {
        if (success) {
          setListAgentData(response);
        }
      }
    );
    setIsSreach(true);
  };

  return (
    <div>
      <Component
        listAgentDataGot={listAgentDataGot}
        listAgentData={listAgentData}
        searchHandler={searchHandler}
        nameQuery={nameQuery}
        setNameQuery={setNameQuery}
        mobileQuery={mobileQuery}
        setMobileQuery={setMobileQuery}
        setPageNumber={setPageNumber}
      />
    </div>
  );
};

export default ListAgent;
